import { Component, Input, ViewChild, ViewContainerRef } from "@angular/core";
import { FormElementToast } from "./types/json-schema";
import { FormProperty } from "./angular2-schema-form-shim";

@Component( {
  selector: 'sp-form-element-toast',
  template: '<div *ngIf="toast && toast.content" [innerHTML]="toast.content" [class]="classes"></div>'
} )
export class FormElementComponentToast {

  @Input()
  toast: FormElementToast = null

  @Input()
  formProperty: FormProperty

  constructor() {
  }

  ngOnInit() {
  }

  get classes() {
    return 'sp-form-element-toast ' + this.toast.classes;
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formelement.toast.component.ts